/*
 * @Description: CTA section - Create Scroll-Stopping Videos Faster Than Ever
 */
import React from 'react';

import StartButton from './StartButton';

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Create Scroll&#8209;Stopping Videos Faster Than Ever
        </h2>

        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Edit clips, fix scenes, and localize content in seconds using FalcoCut&apos;s
          best AI video editing software. The fastest way to transform your ideas into
          pro&#8209;ready videos.
        </p>

        <StartButton text="Edit Your Video Now" />
      </div>
    </section>
  );
};

export default CTASection;
